/**
 * 多语言相关
 */
 (function() {
  var countryList = Object.values(LS.ui.countryInfoMap);
  var languageList = Object.entries(LS.ui.languageMap);
  var countryInfo = LS.ui.countryInfoMap[LS.site.country];
  var curLang = LS.ui.languageMap[LS.site.lang];
  var selectedCountry = '';
  var selectedLanguage = '';
  var changeUrl = ''; // 切换国家语言后的地址
  var changeDir = '';
  var geoPopupShown = 'graecove_geo_popup_shown';
  var storeUserCountry = 'graecove_user_country';
  var switchCountryHandleType = 0;
  var initCustomComplete = false;
  var langConfirmPopupHtml = `
    <div class="ls-vertical-popupbox ls-vertical-popupbox-lang-confirm">
      <div class="ls-vertical-popupbox-overlay"></div>
      <div class="ls-vertical-popupbox-con ls-vertical-popupbox-con_country-lang">
        <div class="popup-country-lang_inner">
          <div class="popup-country-lang_header-wrapper">
            <div class="popup-country-lang_header-title"><%t('public.country_lang_popup.label_confirm') %></div>
            <i class="popup-country-lang_header-close-btn con-close-btn iconfont icon-popup-close"></i>
          </div>

          <div class="popup-country-lang_content-wrapper">
            <p class="popup-lang-confirm_content"><%t('public.country_lang_popup.text_confirm', { curCountry: data.curCountry, targetCountry: data.targetCountry }) %></p>
          </div>

          <div class="popup-country-lang_bind-btn" id="country-lang-confirm-btn">
            <%t('public.country_lang_popup.btn_continue', { targetCountry: data.targetCountry }) %>
          </div>
        </div>
      </div>
    </div>
  `;
  var switchCountryLangHtml = `
    <div class="popup-country-lang switch-country-lang-popup <% if ( data.type == 1 ) { %>geo-tips-popup<% } %>">
      <div class="popup-country-lang_header-wrapper">
        <% if ( data.type == 1 ) { %>
          <div class="popup-country-lang_header-title"><%t('public.country_lang_popup.title_tips') %>
            <div class="popup-country-lang_header-sub-title"><%t('public.country_lang_popup.sub_title_tips') %></div>
          </div>
        <% } else { %>
          <div class="popup-country-lang_header-title"><%t('public.country_lang_popup.title') %></div>
        <% } %>
        <i class="popup-country-lang_header-close-btn lang_header-close-btn iconfont icon-popup-close"></i>
      </div>
      <div class="popup-country-lang_content-wrapper">
        <div class="popup-country-lang_item">
          <% if ( data.type == 1 ) { %>
            <div class="popup-country-lang_item-label"><%t('public.country_lang_popup.label_local_recom') %></div>
          <% } else { %>
            <div class="popup-country-lang_item-label"><%t('public.country_lang_popup.label_country') %></div>
          <% } %>
          <div class="popup-country-lang_item-select-box" id="country-selector" data-key="<%= data.country.key %>">
            <img class="popup-country-lang_item-img country-selected-icon" src="<%= data.country.icon %>" />
            <p class="popup-country-lang_item-text country-selected-text"><%= data.country.text %></p>
            <i class="popup-country-lang_item-arrow iconfont icon-select-arrow-down"></i>

            <div class="popup-country-lang_sub-popup country-selector-popup">
              <% for ( var [index, item] of data.countryList.entries() ) { %>
                <div class="popup-country-lang_sub-item country-popup-sub-item" data-index="<%= index %>" data-key="<%= item.key %>">
                  <img class="popup-country-lang_sub-item-img" src="<%= item.icon %>" />
                  <p class="popup-country-lang_sub-item-text"><%= item.text %></p>
                  <i class="popup-country-lang_sub-item-selected country-selected iconfont icon-check"></i>
                </div>
              <% } %>
            </div>
          </div>
        </div>  

        <div class="popup-country-lang_item" style="display:none;">
          <div class="popup-country-lang_item-label"><%t('public.country_lang_popup.label_lang') %></div>
          <div class="popup-country-lang_item-select-box" id="lang-selector" data-key="<%= data.lang.key %>">
            <p class="popup-country-lang_item-text lang-selected-text"><%= data.lang.text %></p>
            <i class="popup-country-lang_item-arrow iconfont icon-select-arrow-down"></i>

            <div class="popup-country-lang_sub-popup lang-selector-popup">
              <% for ( var item of data.languageList ) { %>
                <div class="popup-country-lang_sub-item lang-popup-sub-item" data-key="<%= item[0] %>">
                  <p class="popup-country-lang_sub-item-text"><%= item[1] %></p>
                  <i class="popup-country-lang_sub-item-selected lang-selected iconfont icon-check"></i>
                </div>
              <% } %>
            </div>
          </div>
        </div>  
      </div>
      <div class="popup-country-lang_bind-btn" id="country-lang-submit-btn" data-type="<%= data.type %>">
        <% if ( data.type == 1 ) { %>
          <%t('public.country_lang_popup.btn_confirm') %>
        <% } else { %>
          <%t('public.country_lang_popup.btn_save') %>
        <% } %>
      </div>
    </div>
  `;
  var switchCountryHtml = `
    <div class="popup-con_country switch-country-popup">
      <% for ( var [index, item] of data.countryList.entries() ) { %>
        <div class="popup-country_item country-popup-item" data-index="<%= index %>" data-key="<%= item.key %>">
          <img class="popup-country_item-img" src="<%= item.icon %>" />
          <p class="popup-country_item-text"><%= item.text %></p>
          <i class="popup-country_item-selected country-selected iconfont icon-check"></i>
        </div>
      <% } %>
    </div>
  `;
  var i18nFn = {
    /**
     * 通过本地cookie字段localization判断用户所在国家
     * @returns 
     */
     getUserCountry() {
      var userCountrySesstion = 'graecoev_user_country';
      if (sessionStorage.getItem(userCountrySesstion)) return;
      var chList = ['emd.market', 'kol.tt', 'kol.yt', 'kol.ins', 'kol.fb'];
      var curChannel = LS.cookie.get('looksky-ch');
      if (chList.indexOf(curChannel) >= 0) {
        setTimeout(function() {
          var userCountry = localStorage.getItem(storeUserCountry) || '';
          var localization = LS.cookie.get('localization');
          if (!userCountry) {
            localStorage.setItem(storeUserCountry, localization);
          } else {
            if (userCountry !== localization) {
              i18nFn.openSwitchCountryLangPopup(userCountry);
              sessionStorage.setItem(userCountrySesstion, 1);
            }
          }
        }, 1000);
       
      };
    },
    /**
     * 获取当前ip信息
     */
     getGeoInfo() {
      if (location.href.indexOf('au.graecove') >= 0) return;
      LS.ajax({
        url: `${location.origin}/browsing_context_suggestions.json?source=geolocation_recommendation`, 
        type : 'get', 
        headers:{ 'Content-Type': 'application/graphql' }, 
        success: function(res) {
          var resCountry = res && res.detected_values && res.detected_values.country && res.detected_values.country.handle ? res.detected_values.country.handle : '';
          var geoPopupFlag = sessionStorage.getItem(geoPopupShown);
          if (!resCountry) return;
          if ((!geoPopupFlag || geoPopupFlag !== '1') && LS.ui.countryInfoMap[resCountry]) {
            i18nFn.handleGeoRecom(resCountry);
          }
        },
        error: function (e) {},
      })
    },
    /**
     * 根据地理位置推荐切换国家
     */
    handleGeoRecom(geoCountry) {
      if (geoCountry !== LS.site.country) {
        i18nFn.openSwitchCountryLangPopup(geoCountry);
        sessionStorage.setItem(geoPopupShown, 1);
      }
    },
    /**
     *  自定义国家点击事件,在业务页面调用，处理不同的回调
     * @param {function} callback 
     */
     customClickCountryItem: function(callback) {
      if (initCustomComplete) return;
      $(document).on('click', '.switch-country-popup .country-popup-item', function() {
        var selectedKey = $(this).attr('data-key');
        var module = '.i18n-lang-module-custom';
        var countryName = LS.ui.countryInfoMap[selectedKey].name;
        callback && typeof callback === "function" && callback(selectedKey, this);
        $(this).find('.popup-country_item-selected').show();
        $(this).siblings().find('.popup-country_item-selected').hide();
        $('.switch-country-popup').hide();
        $(module).find('.i18n-lang-module_selector-text').text(countryName);
        $('.i18n-lang-module').attr('data-key', selectedKey);
        $(module).find('.i18n-lang-module_selector-arrow').removeClass('icon-select-arrow-up').addClass('icon-select-arrow-down');
      })
      initCustomComplete = true;
    },
    insertLangModuleInHeader: function() {
      var html = `
        <img class="header-lang-module_img" src=${countryInfo.icon} />
      `;
      $('#header-lang_pc').html(html);   
    },
    /**
     * 移除弹窗，避免同时存在多个弹窗
     */
     removeSwitchCountryPopup: function() {
      $('.switch-country-popup').remove();
    },
    openSwitchCountryPopup: function() {
      var popupCls = '.switch-country-popup';
      if (!$(popupCls).length) {
        var tmpl = LS.tmpl(switchCountryHtml, { countryList: countryList });
        $('.i18n-lang-module').length && $('.i18n-lang-module').append(tmpl);
      }
      $('.switch-country-popup').show();
    },
    openSwitchCountryLangPopup: function(geoCountry, left) {
      var popupCls = '.switch-country-lang-popup';
      !selectedCountry && (selectedCountry = LS.site.country);
      !selectedLanguage && (selectedLanguage = LS.site.lang);
      if (!$(popupCls).length) {
        var params = i18nFn.matchCountryLang(geoCountry);
        var tmpl = LS.tmpl(switchCountryLangHtml, params);
        geoCountry ? $('body').append(tmpl) : $('.web-header').append(tmpl);
        if (left) {
          $('.switch-country-lang-popup').css({
            left: (left - 280) + 'px'
          })
        }
        i18nFn.reportShowPopup(geoCountry);
        return;
      }
      $(popupCls).show();
      i18nFn.reportShowPopup(geoCountry);
    },
    reportGeoTipsPopup: function(eid, ext1) {
      var geoCountryText = $('.country-selected-text').text();
      var geoLangText = $('.lang-selected-text').text();
      LS.stat({
        eid: LS.ui.reportType[eid],
        ext1: LS.ui.i18nReportMap[ext1],
        ext2: 'local=' + geoCountryText,
        ext3: 'local=' + geoLangText
      })
    },
    reportShowPopup: function(geoCountry) {
      if (geoCountry) {
        i18nFn.reportGeoTipsPopup('moduleShow', 'showGeoTipsPopup');
      } else {
        LS.stat({
          eid: LS.ui.reportType['moduleShow'],
          ext1: LS.ui.i18nReportMap['showPopup']
        })
      }
    },
    matchCountryLang: function(geoCountry) {
      var result = {
        countryList: countryList,
        languageList: languageList,
        type: geoCountry ? 1 : 2
      }
      if (geoCountry) {
        var geoCountryData = LS.ui.countryInfoMap[geoCountry];
        result.country = {
          icon: geoCountryData.icon,
          text: geoCountryData.text,
          key: geoCountryData.key
        }
        result.lang = {
          text: LS.ui.languageMap[geoCountryData.lang],
          key: geoCountryData.lang
        }
      } else {
        result.country = {
          icon: countryInfo.icon,
          text: countryInfo.text,
          key: countryInfo.key
        }
        result.lang = {
          text: curLang,
          key: LS.site.lang
        }
      }
      return result;
    },
    submitCountryLang: function() {
      return new Promise(function(reslove, reject) {
        LS.ajax({
          url: LS.ui.routes.changeUserLanguage,
          type: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({
            languageCode: selectedLanguage
          }),
          success: function(res) {
            if (res.hasError || res.code !== '0') {
              LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
              reject();
              return;
            };
            reslove();
          },
          error: function (error) {
            LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
            reject();
          },
        })
      })
    },
    handleDir: function(selectedLanguage, selectedCountry) {
      var dir = '/' + selectedLanguage + '-' + selectedCountry.toLowerCase();
      if (dir === '/en-us') dir = '/';
      if (dir.indexOf('-us')) dir = dir.replace('-us', '');
      return dir;
    },
    handleChangeUrl: function(self, btnType) {
      var isLogin = LS.ui.isLogin();
      if(btnType == 1) {
        var geoCountry = $('#country-selector').attr('data-key');
        var geoLang = $('#lang-selector').attr('data-key');
        changeDir = i18nFn.handleDir(geoLang, geoCountry);
      } else {
        changeDir = i18nFn.handleDir(selectedLanguage, selectedCountry);
      }
      if (!selectedLanguage || !selectedCountry || LS.site.dir === changeDir) {
        $('.switch-country-lang-popup').hide();
        return;
      }
      changeUrl = i18nFn.getChangeUrl();
      if (isLogin && selectedCountry !== LS.site.country) {
        var targetCountry = LS.ui.countryInfoMap[selectedCountry];
        var tmpl = LS.tmpl(langConfirmPopupHtml, { curCountry: countryInfo.name, targetCountry: targetCountry.name });
        $('body').append(tmpl);
        return;
      }
      location.replace(changeUrl);
    },
    /**
     * 
     * @param {number} type 1获取首页 0获取当前页
     */
    getChangeUrl: function(type = 0) {
      var url = '';
      var isHomepage = LS.site.page === 'index' || type === 1; // 是否是首页
      // 跳转到默认站点
      if (changeDir === '/') {
        url = isHomepage 
          ? location.origin // https://www.graecove.com/
          : location.origin + location.pathname.replace(LS.site.dir, changeDir.substring(1));  // https://www.graecove.com/fr-fr => https://www.graecove.com/
      } else {
        url = isHomepage 
          ? location.origin + changeDir // https://www.graecove.com/fr-fr => https://www.graecove.com/it-it
          // https://www.graecove.com/products/teagan-linen-v-neck-empire-waisted-relaxed-fit-tea-length-dress => // https://www.graecove.com/it-it/products/teagan-linen-v-neck-empire-waisted-relaxed-fit-tea-length-dress
          // https://www.graecove.com/fr-fr/products/teagan-linen-v-neck-empire-waisted-relaxed-fit-tea-length-dress => // https://www.graecove.com/it-it/products/teagan-linen-v-neck-empire-waisted-relaxed-fit-tea-length-dress
          : LS.site.dir === '/' || LS.site.dir === '' ? location.origin + changeDir + location.pathname : location.href.replace(LS.site.dir, changeDir); 
      }
      return url;
    },
    bindEvent: function() {
      $(document).on('click', '.popup-country-lang_header-close-btn', function() {
        var isGeoTipsPopup = $('.switch-country-lang-popup').hasClass('geo-tips-popup');
        if (isGeoTipsPopup) {
          $('.switch-country-lang-popup').remove();
          i18nFn.reportGeoTipsPopup('click', 'closeGeoTipsPopup');
        } else {
          $('.switch-country-lang-popup').hide();
          $('.header-lang-module').removeClass('active');
          LS.stat({
            eid: LS.ui.reportType['click'],
            ext1: LS.ui.i18nReportMap['closePopup']
          })
        }
      });

      $(document).on('click', '.lang_header-close-btn', function() {
       
      });

      // 切换国家语言按钮
      $(document).on('click', '#header-lang_pc', function() {
        var isShow = $('.switch-country-lang-popup').css('display') === 'block';
        var fixLeft = $('#header-lang_pc')[0].getBoundingClientRect().left;
        if (isShow) {
          $('.header-lang-module').removeClass('active');
          $('.switch-country-lang-popup').hide();
        } else {
          $('.header-lang-module').addClass('active');
          i18nFn.openSwitchCountryLangPopup('', fixLeft);
          LS.stat({
            eid: LS.ui.reportType['click'],
            ext1: LS.ui.i18nReportMap['clickHeaderBtn']
          })
        }
      });

      // 切换国家按钮
      $(document).on('click', '.switch-country-btn', function() {
        switchCountryHandleType = $(this).attr('data-custom') || '';
        toggleCountryPopup();
      });
      
      $(document).on('click', '#country-selector', function() {
        toggleSubPopup(this, '#lang-selector');
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.i18nReportMap['clickCountrySelector']
        })
      });

      $(document).on('click', '#lang-selector', function() {
        toggleSubPopup(this, '#country-selector');
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.i18nReportMap['clickLangSelector']
        })
      });

      $(document).on('click', '.switch-country-popup .country-popup-item', async function() {
        if (switchCountryHandleType === 'self') return;
        var country = $(this).attr('data-key');
        var targetCountry = LS.ui.countryInfoMap[country];
        changeDir = i18nFn.handleDir(targetCountry.lang, targetCountry.key.toLowerCase());
        await i18nFn.submitCountryLang();
        changeUrl = i18nFn.getChangeUrl();
        changeUrl = LS.addParam({ loginPop: 1 }, changeUrl);
        location.replace(changeUrl);
      });

      $(document).on('click', '.country-selector-popup .country-popup-sub-item', function() {
        var $target = $(this);
        var index = $target.attr('data-index');
        var country = countryList[index];
        var $selector = $('#country-selector');
        $target.find('.country-selected').show();
        $target.siblings().find('.country-selected').hide();
        $selector.attr('data-key', country.key);
        $selector.find('.country-selected-icon').attr('src', country.icon);
        $selector.find('.country-selected-text').text(country.text);
        selectedCountry = country.key;

        // 设置默认语言
        var defalutLang = country.lang;
        var $langSelector = $('#lang-selector');
        $langSelector.attr('data-key', defalutLang);
        $langSelector.find('.lang-selected-text').text(LS.ui.languageMap[defalutLang]);
        selectedLanguage = defalutLang;

        reportSelectorInfo(1, LS.site.country, selectedCountry);
      });

      $(document).on('click', '.lang-selector-popup .lang-popup-sub-item', function() {
        var $target = $(this);
        var lang = $target.attr('data-key');
        var selectedLang = $target.find('.popup-country-lang_sub-item-text').text();
        var $selector = $('#lang-selector');
        $target.find('.lang-selected').show();
        $target.siblings().find('.lang-selected').hide();
        $selector.attr('data-key', lang);
        $selector.find('.lang-selected-text').text(selectedLang);
        selectedLanguage = lang;

        reportSelectorInfo(2, LS.site.lang, selectedLanguage);
      });

      $(document).on('click', '#country-lang-submit-btn', function() {
        var btnType = $(this).attr('data-type');
        i18nFn.handleChangeUrl(this, btnType);

        var isGeoTipsPopup = $('.switch-country-lang-popup').hasClass('geo-tips-popup');
        if (isGeoTipsPopup) {
          i18nFn.reportGeoTipsPopup('click', 'comfirmGeoTipsPopup');
        } else {
          LS.stat({
            eid: LS.ui.reportType['click'],
            ext1: LS.ui.i18nReportMap['savePopup']
          })
        }
      });

      $(document).on('click', '#country-lang-confirm-btn', async function() {
        // 切换国家，移除登录态token、userid
        LS.user.delUserInfo();
        // 登录退出
        LS.ui.loginFn.logout && LS.ui.loginFn.logout();
        try {
          await i18nFn.submitCountryLang();
        } catch(e) {}
        var isAuthPage = LS.ui.authList.find(item => location.href.indexOf(item) >= 0);
        if (isAuthPage) {
          changeUrl = i18nFn.getChangeUrl(1);
          changeUrl = LS.addParam({ loginPop: 1 }, changeUrl);
        }
        location.replace(changeUrl);
      });

      function toggleCountryPopup() {
        var $countryPop = $('.switch-country-popup');
        var isShow = $countryPop.css('display') === 'block';
        var $arrow = $('.i18n-lang-module').find('.i18n-lang-module_selector-arrow');
        var selectedKey = $('.i18n-lang-module').attr('data-key');
        if (isShow) {
          $countryPop.hide();
          $arrow.removeClass('icon-select-arrow-up').addClass('icon-select-arrow-down');
        } else {
          i18nFn.openSwitchCountryPopup();
          $arrow.removeClass('icon-select-arrow-down').addClass('icon-select-arrow-up');

          var $countryPopItems = $('.switch-country-popup').find('.country-popup-item');
          for (var i = 0, len = $countryPopItems.length; i < len; i ++) {
            var target = $($countryPopItems[i]);
            var countryItemKey = target.attr('data-key');
            if (countryItemKey === selectedKey) {
              target.find('.popup-country_item-selected').show();
            } else {
              target.find('.popup-country_item-selected').hide();
            }
          }
        }
      }

      function toggleSubPopup(self, siblings) {
        var $subPop = $(self).children('.popup-country-lang_sub-popup');
        var isShow = $subPop.css('display') === 'block';
        var $arrow = $(self).children('.popup-country-lang_item-arrow');
        var selectedKey = $(self).attr('data-key');
        var $subPopItems = $subPop.find('.popup-country-lang_sub-item');
        if (isShow) {
          $subPop.hide();
          $arrow.removeClass('icon-select-arrow-up').addClass('icon-select-arrow-down');
        } else {
          $(siblings).children('.popup-country-lang_sub-popup').hide();
          $(siblings).children('.popup-country-lang_item-arrow').removeClass('icon-select-arrow-up').addClass('icon-select-arrow-down');
          $subPop.show();
          $arrow.removeClass('icon-select-arrow-down').addClass('icon-select-arrow-up');

          for (var i = 0, len = $subPopItems.length; i < len; i ++) {
            var target = $($subPopItems[i]);
            var subItemKey = target.attr('data-key');
            if (subItemKey === selectedKey) {
              target.find('.popup-country-lang_sub-item-selected').show();
            } else {
              target.find('.popup-country-lang_sub-item-selected').hide();
            }
          }
        }
      }

      function reportSelectorInfo(type, before, last) {
        var ext1 = type === 1 ? LS.ui.i18nReportMap['changeCountry'] : LS.ui.i18nReportMap['changeLang'];
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: ext1,
          ext2: before,
          ext3: last
        })
      }
    }
  }

  function init() {
    // i18nFn.getGeoInfo();
    i18nFn.getUserCountry();
    i18nFn.bindEvent();
    i18nFn.insertLangModuleInHeader();
  }

  init();

  LS.ui.i18nFn = {
		openSwitchCountryLangPopup: i18nFn.openSwitchCountryLangPopup,
    removeSwitchCountryPopup: i18nFn.removeSwitchCountryPopup,
		customClickCountryItem: i18nFn.customClickCountryItem
	};
})();